import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class OperatoriService {
    private basePath = environment.interop.basePath;

    private listUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.operatori.list;
    private updateActiveUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.operatori.updateActive;
    private updatePublicUrl = this.basePath + environment.interop.dgaspc.activitati.nomenclatoare.operatori.updatePublic;

    constructor(private http: HttpClient) { }

    list() {
        return this.http.post(this.listUrl, {});
    }

    changeStatusActive(id: number) {
        return this.http.put(this.updateActiveUrl + id, {});
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.updatePublicUrl + id, {});
    }
}
